import React from 'react'

const items = [
    { text: '“Metatech Official developed a medical app for my dental clinic with smooth functionality and an easy-to-use interface. Their experienced team proved why they are a trusted app developer in Pakistan for growing businesses.”', name: 'Dr. Usman Raza', role: 'Dentist' },
    { text: '“Our fitness tracking mobile app exceeded expectations in both performance and design. Working with such a professional mobile application design company made the entire development journey simple and stress-free.”', name: 'Sarah Ahmed', role: 'Fitness Coach & Entrepreneur' },
    { text: '“We wanted a scalable Android application for our ecommerce business, and Metatech Official delivered exactly what we needed. Their expertise as an Android app development agency helped us launch faster with excellent user experience.”', name: 'Raven Chow', role: 'Ecommerce Business Owner' },
    { text: '“After comparing multiple app development companies in Pakistan, we chose Metatech Official for our healthcare app project. Their communication skills and technical knowledge throughout the process were outstanding.”', name: 'Dr. Hina Malik', role: 'Healthcare Consultant' },
    { text: '“Our food delivery application was completed on time with all custom features integrated smoothly.”', name: 'Chris White', role: 'Startup Founder' },
    { text: '"Metatech Official built a modern educational app for our institute with excellent UI and performance optimisation. Their attention to detail and commitment to quality truly impressed our team.”', name: 'Mariam Khan', role: 'Education Consultant' },
]

export default function Testimonials2({ items: customItems, heading = 'What Our Clients Say About Metatech Official' }) {
    const testimonials = customItems || items
    return (
        <section className='rounded-4' style={{ backgroundColor: '#0f0f12' }}>
            <div className="container py-5">
                <div className="text-center mb-4">
                    <h2 className="text-light">{heading}</h2>
                </div>
                <div className="row">
                    {testimonials.map((t, i) => (
                        <div key={i} className="col-xl-4 col-lg-6 col-md-6 my-2">
                            <div className="p-4 rounded-4 h-100" style={{ backgroundColor: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)' }}>
                                <div className="mb-2">
                                    <i className="fa fa-star text-warning mx-1  "></i>
                                    <i className="fa fa-star text-warning mx-1  "></i>
                                    <i className="fa fa-star text-warning mx-1  "></i>
                                    <i className="fa fa-star text-warning mx-1  "></i>
                                </div>
                                <div className="text-light text-opacity-90" style={{ minHeight: '72px' }}>
                                    <p className="m-0">{t.text}</p>
                                </div>
                                <div className="d-flex align-items-center pt-3">
                                    <div className="rounded-circle me-3 d-flex justify-content-center align-items-center" style={{ width: 40, height: 40, backgroundColor: 'rgba(255,255,255,0.08)' }} >
                                        <i className="fa fa-lg fa-user text-light"></i>
                                        </div>
                                    <div>
                                        <p className="m-0 text-light">{t.name}</p>
                                        <span className="text-light text-opacity-75 small">{t.role}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
